<template>
  <div class="card mb-25 border-0 rounded-0 bg-white letter-spacing">
    <div
      class="card-head box-shadow bg-white d-lg-flex align-items-center justify-content-between p-15 p-sm-20 p-md-25"
    >
      <div class="d-sm-flex align-items-center">
        <router-link
          to="/add-colis"
          class="default-btn position-relative transition border-0 fw-medium text-white pt-11 pb-11 ps-25 pe-25 pt-md-12 pb-md-12 ps-md-30 pe-md-30 rounded-1 bg-success fs-md-15 fs-lg-16 d-inline-block me-10 mb-10 mb-lg-0"
          v-if="auth.can('ADD_PARCEL')"
        >
          Nouveau Colis
          <i class="flaticon-plus position-relative ms-5 fs-12"></i>
        </router-link>
      </div>
      <div class="d-sm-flex align-items-center">
          <input
            type="text"
            class="form-control shadow-none text-black rounded-0"
            placeholder="chercher colis"
            v-model="searchTerm"
            @input="handleInput"
          />
          
        <div
            class="select-calendar position-relative me-sm-10 ms-sm-15 mt-10 mt-sm-0"
        >
          <!-- <i class="flaticon-calendar lh-1 icon"></i>
          <input
            ref="leadCalendar"
            type="text"
            class="form-control flatpickr shadow-none fw-medium text-black fs-md-15 fs-lg-16"
            id="lead-calendar"
          /> -->
          <div
            class="col-12 p-2 border col-md-auto m-auto"
            style="cursor: pointer"
            @click="showCalendar()"
            >
            {{ selectedDate && selectedDate[0] ? selectedDate[0].format("DD MMM, YYYY") : "" }} -
            {{ selectedDate && selectedDate[1] ? selectedDate[1].format("D MMM, YYYY") : "" }}
            <i class="flaticon-calendar" style="float: right;"></i>
            </div>
            <div
            v-show="showCalendarBox"
            style="
              position: absolute;
              right: 0%;
              top: 50px;
              transform: translateX(-50%);
              z-index: 999;
              background: #fff;
              box-shadow: 0 2px 16px rgba(0,0,0,0.15);
              border-radius: 8px;
              padding: 16px;
              /* min-width: 320px; */
              width: auto;
            "
            >
            <MyDateRangePicker
              v-model="selectedDate"
              @onSelect="showCalendar"
              :next-prev-icon="true"
              :last-month="todayDt"
              :first-month="firstDt"
              :enableSecondCalendar="true"
            />
            </div>
        </div>
        <button
          class="dot-btn lh-1 position-relative top-3 bg-transparent border-0 shadow-none p-0 transition d-inline-block mt-10 mt-sm-0"
          type="button"
          data-bs-toggle="modal"
          data-bs-target="#filterLeadModal"
        >
          <i class="flaticon-dots"></i>
        </button>
      </div>
    </div>
    <div class="card-body p-15 p-sm-20 p-md-25">
      <div class="d-flex align-items-center mb-20">
        <label class="me-2 text-paragraph fw-medium">Afficher :</label>
        <select
          class="form-select form-select-sm w-auto"
          v-model="filter.per_page"
          @change="changePerPage"
        >
          <option :value="10">10</option>
          <option :value="50">50</option>
          <option :value="100">100</option>
          <option :value="500">500</option>
        </select>
        <span class="ms-2 text-paragraph">lignes</span>
      </div>
      <div class="table-responsive table-scroll-mobile">
        <table class="table text-nowrap align-middle mb-0">
          <thead>
            <tr>
              <th
                scope="col"
                class="text-uppercase fw-medium shadow-none text-body-tertiary fs-13 pt-0 ps-0"
              >
                Code d'envoi
              </th>
              <th
                scope="col"
                class="text-uppercase fw-medium shadow-none text-body-tertiary fs-13 pt-0"
              >
                Dernière mise à jour
              </th>
              <th
                scope="col"
                class="text-uppercase fw-medium shadow-none text-body-tertiary fs-13 pt-0"
              >
                Destinataire
              </th>
              <th
                scope="col"
                class="text-uppercase fw-medium shadow-none text-body-tertiary fs-13 pt-0"
              >
                Magasin
              </th>
              <th
                scope="col"
                class="text-uppercase fw-medium shadow-none text-body-tertiary fs-13 pt-0"
              >
                Etat
              </th>
              <th
                scope="col"
                class="text-uppercase fw-medium shadow-none text-body-tertiary fs-13 pt-0"
              >
                Status
              </th>
              <th
                scope="col"
                class="text-uppercase fw-medium shadow-none text-body-tertiary fs-13 pt-0"
              >
                Ville
              </th>
              <th
                scope="col"
                class="text-uppercase fw-medium shadow-none text-body-tertiary fs-13 pt-0"
              >
                Prix
              </th>
              <th
                scope="col"
                class="text-uppercase fw-medium shadow-none text-body-tertiary fs-13 pt-0 text-end pe-0"
              ></th>
            </tr>
          </thead>
          <tbody>
            <tr v-for="(row, index) in rows" :key="index">
              <th
                class="shadow-none lh-1 fw-medium text-black-emphasis title ps-0"
              >
                <div class="d-flex align-items-center">
                  <h6 v-if="row.replace === 1" class="text-warning">
                    {{ row.code }}
                    <i class="ph ph-repeat"></i>
                  </h6>
                  <h6 v-else-if="row.partial === 1" class="text-info">
                    {{ row.code }}
                    <i class="ph ph-arrows-down-up"></i>
                  </h6>
                  <h6 v-else>
                    {{ row.code }}
                  </h6>
                </div>
              </th>
              <td class="shadow-none lh-1 fw-medium text-black-emphasis">
                {{ getDate(row.updated_at) }}
              </td>
              <td class="shadow-none lh-1 fw-medium text-black-emphasis">
                <p class="text-nowrap">
                  <b>{{ row.receiver }}</b> <br />
                  <b>{{ oldPhone(row.phone) }}</b> <br />
                </p>
              </td>
              <td class="shadow-none lh-1 fw-medium text-black-emphasis">
                <b v-if="row.magasin_name">Magasin : {{ row.magasin_name }} </b>

                <div v-else class="text-nowrap">
                  {{ row.customer_name }}<br />
                  {{ oldPhone(row.customer_phone) }}
                </div>
              </td>
              <td class="shadow-none lh-1 fw-medium text-black-emphasis">
                <span
                  :class="`badge text-outline-${resolveUserStatusVariant(
                    row.situation
                  )}`"
                >
                  {{ resolveStatuParcel(row.situation) }}
                </span>
              </td>

              <td class="shadow-none lh-1 fw-medium text-black-emphasis">
                <div
                  class="rounded-pill fs-13 badge text-bg-black custom-badge"
                  :style="{ '--dynamic-bg': getBadgeConfig(row).color }"
                >
                  {{ getBadgeConfig(row).text }}
                  <template v-if="getBadgeConfig(row).date">
                    <br />{{ getBadgeConfig(row).date }}
                  </template>
                  <template v-if="getBadgeConfig(row).comment">
                    <br />{{ getBadgeConfig(row).comment }}
                  </template>
                </div>
              </td>
              <td class="shadow-none lh-1 fw-medium text-black-emphasis">
                <b>{{ row.city_name }}</b
                ><br />
                <p v-if="row.quartier && row.quartier.name">
                  {{ row.quartier.name }}
                </p>
              </td>
              <td class="shadow-none lh-1 fw-medium text-black-emphasis">
                <b>{{ row.price }} </b>Dhs<br />
                <p style="word-wrap: break-word; width: 50%">
                  {{ row.product_nature }}
                </p>
              </td>

              <td
                class="shadow-none lh-1 fw-medium text-body-tertiary text-end pe-0"
              >
                <div class="dropdown">
                  <button
                    class="dropdown-toggle lh-1 bg-transparent border-0 shadow-none p-0 transition"
                    type="button"
                    data-bs-toggle="dropdown"
                    aria-expanded="false"
                  >
                    <i class="flaticon-dots"></i>
                  </button>
                  <ul class="dropdown-menu">
                    <li>
                      <button
                        class="dropdown-item d-flex align-items-center"
                        @click="showDetails(row)"
                      >
                        <i
                          class="flaticon-view lh-1 me-8 position-relative top-1"
                        ></i>
                        Détails
                      </button>
                    </li>

                    <li>
                      <button
                        class="dropdown-item d-flex align-items-center"
                        @click="showDetailSuivi(row)"
                      >
                        <i
                          class="flaticon-clock lh-1 me-8 position-relative top-1"
                        ></i>
                        Historique
                      </button>
                    </li>
                    <li
                      v-if="
                        auth.can('PARCELS') &&
                        (user.role_id == 1 || user.role_id == 2) &&
                        row.status != 'NEW_PARCEL' &&
                        row.status != 'WAITING_PICKUP' &&
                        row.status != 'RETURNED' &&
                        (row.situation != 'Facturé' ||
                          row.situation != 'INVOICED')
                      "
                    >
                      <a
                        class="dropdown-item d-flex align-items-center"
                        href="javascript:void(0);"
                        @click="showUpdate(row)"
                      >
                        <i
                          class="flaticon-pen lh-1 me-8 position-relative top-1"
                        ></i>
                        Modifier
                      </a>
                    </li>
                    <li
                      v-if="
                        auth.can('PARCELS') &&
                        row.status === 'NEW_PARCEL' &&
                        auth.can('TRASH_PARCEL_ADMIN')
                      "
                    >
                      <a
                        class="dropdown-item d-flex align-items-center"
                        href="javascript:void(0);"
                        @click="Destroy_Coli(row)"
                      >
                        <i
                          class="flaticon-delete lh-1 me-8 position-relative top-1"
                        ></i>
                        Supprimer
                      </a>
                    </li>
                  </ul>
                </div>
              </td>
            </tr>
          </tbody>
        </table>
      </div>
      <div
        class="pagination-area d-flex flex-wrap mt-15 mt-md-25 mb-0 justify-content-between align-items-center gap-2"
      >
        <div class="d-flex align-items-center">
          <label class="me-2 text-paragraph fw-medium">Afficher :</label>
          <select
            class="form-select form-select-sm w-auto"
            v-model="filter.per_page"
            @change="changePerPage"
          >
            <option :value="10">10</option>
            <option :value="50">50</option>
            <option :value="100">100</option>
            <option :value="500">500</option>
          </select>
          <span class="ms-2 text-paragraph">lignes</span>
        </div>
        <p class="mb-0 text-paragraph">
          Showing
          <span class="fw-bold">{{ (filter.current_page - 1) * filter.per_page + 1 }}</span>
          –
          <span class="fw-bold">{{ Math.min(filter.current_page * filter.per_page, filter.total) }}</span>
          out of <span class="fw-bold">{{ filter.total }}</span> results
        </p>
        <nav>
          <ul class="pagination mb-0 flex-wrap">
            <!-- Previous -->
            <li class="page-item" :class="{ disabled: filter.current_page === 1 }">
              <a
                class="page-link"
                href="javascript:void(0)"
                aria-label="Previous"
                @click="goToPage(filter.current_page - 1)"
              >
                <i class="flaticon-chevron-1"></i>
              </a>
            </li>

            <!-- Page numbers with ellipsis -->
            <template v-for="(page, index) in paginatedPages" :key="index">
              <li v-if="page === '...'" class="page-item disabled">
                <span class="page-link">…</span>
              </li>
              <li v-else class="page-item" :class="{ active: filter.current_page === page }">
                <a
                  href="javascript:void(0)"
                  class="page-link"
                  @click="goToPage(page as number)"
                >
                  {{ page }}
                </a>
              </li>
            </template>

            <!-- Next -->
            <li class="page-item" :class="{ disabled: filter.current_page === filter.last_page }">
              <a
                class="page-link"
                href="javascript:void(0)"
                aria-label="Next"
                @click="goToPage(filter.current_page + 1)"
              >
                <i class="flaticon-chevron"></i>
              </a>
            </li>
          </ul>
        </nav>
      </div>
    </div>
  </div>

  <!-- Modal Filter -->
  <div class="modal fade" id="filterLeadModal" tabindex="-1" aria-hidden="true">
    <div class="modal-dialog modal-dialog-centered modal-lg">
      <div class="modal-content p-15 p-md-40">
        <div class="modal-header">
          <h1 class="modal-title fs-5">Filtrer</h1>
          <button
            type="button"
            class="btn-close"
            data-bs-dismiss="modal"
            aria-label="Close"
          ></button>
        </div>

        <div class="modal-body">
          <form class="row">
            <!-- Magasin -->
            <div class="col-md-4">
              <div class="form-group mb-3">
                <label>Magasin:</label>
                <v-select
                  class="custom-select-height"
                  v-model="client_filter"
                  label="name"
                  :options="clientList"
                  @search="filterClients"
                />
              </div>
            </div>

            <!-- Zone -->
            <div class="col-md-4">
              <div class="form-group mb-3">
                <label>Zone:</label>
                <v-select
                  class="custom-select-height"
                  v-model="zone_filter"
                  label="name"
                  :options="zonesList"
                />
              </div>
            </div>

            <!-- Ville -->
            <div class="col-md-4">
              <div class="form-group mb-3">
                <label>Ville:</label>
                <v-select
                  class="custom-select-height"
                  v-model="city_filter"
                  label="name"
                  :options="citiesList"
                />
              </div>
            </div>

            <!-- Livreur -->
            <div class="col-md-4">
              <div class="form-group mb-3">
                <label>Livreur:</label>
                <v-select
                  class="custom-select-height"
                  v-model="liv_filter"
                  style="border-color: #0000002b"
                  label="name"
                  :options="livreurList"
                  @search="onSearchDrivers"
                >
                  <!--  -->
                  <template #no-options>
                    Taper un mot pour chercher un livreur
                  </template>
                </v-select>
              </div>
            </div>

            <!-- Etat -->
            <div class="col-md-4">
              <div class="form-group mb-3">
                <label>Etat:</label>
                <v-select
                  class="custom-select-height"
                  v-model="etat_filter"
                  style="border-color: #0000002b"
                  label="name"
                  :options="etatList"
                />
              </div>
            </div>

            <!-- Status -->
            <div class="col-md-4">
              <div class="form-group mb-3">
                <label>Status:</label>
                <v-select
                  class="custom-select-height"
                  v-model="status_filter"
                  style="border-color: #0000002b"
                  label="name"
                  :options="status"
                />
              </div>
            </div>

            <!-- Par Date de -->
            <div class="col-md-4">
              <div class="form-group mb-3">
                <label>Par Date de:</label>
                <select v-model="type_date_filter" class="form-control">
                  <option value="ADD_DATE">Date de création</option>
                  <option value="LAST_UPDATE">Dernière Mise à jour</option>
                  <option value="PICKED_DATE">Date de ramassage</option>
                  <option value="SENT_DATE">Date d'expédition</option>
                  <option value="DELIVERY_DATE">Date de livraison</option>
                  <option value="POSTPONED_DATE">Date reportée</option>
                </select>
              </div>
            </div>

            <!-- Ajouté Au BPL -->
            <div class="col-md-4">
              <div class="form-group mb-3">
                <label>Ajouté Au BPL:</label>
                <select v-model="add_bp_filter" class="form-control">
                  <option value="">Tous</option>
                  <option value="0">Non Ajouté Au BPL</option>
                  <option value="1">Ajouté Au BPL et Non Payé</option>
                </select>
              </div>
            </div>

            <!-- Afficher Réf -->
            <div class="col-md-4">
              <div class="form-group mb-3">
                <label>Afficher Réf:</label>
                <select v-model="ref_filter" class="form-control">
                  <option value="">Tous</option>
                  <option value="1">Afficher les Ref</option>
                  <option value="0">Ne pas afficher les Refs</option>
                </select>
              </div>
            </div>

            <!-- Prix 0DH (with permission) -->
            <template v-if="auth.can('FILTER_PARCEL_PRICE')">
              <div class="col-md-4">
                <div class="form-group mb-3">
                  <label>Prix 0DH:</label>
                  <select v-model="price_filter" class="form-control">
                    <option value="">Tous</option>
                    <option value="1">Oui</option>
                    <option value="0">Non</option>
                  </select>
                </div>
              </div>
            </template>

            <!-- Par Date -->
            <!-- <div class="col-md-4">
              <div class="form-group mb-3">
                <label>Par Date:</label>
              </div>
            </div> -->
          </form>
        </div>

        <div class="modal-footer">
          <!-- <button
            type="button"
            class="btn btn-secondary"
            data-bs-dismiss="modal"
          >
            Fermer
          </button> -->
          <button type="button" @click="filterList" class="btn btn-primary">
            Filtrer
          </button>
          <button type="button" @click="removeFilter" class="btn btn-warning">
            Annuler
          </button>
        </div>
      </div>
    </div>
  </div>
  <!-- exported todaycolis modal -->
  <div class="modal fade" id="modalExortToday" tabindex="-1" aria-hidden="true">
    <div class="modal-dialog modal-xl">
      <div class="modal-content">
        <div class="modal-header">
          <h1 class="modal-title fs-5">Colis reportés pour aujourd'hui</h1>
          <button
            type="button"
            class="btn-close"
            data-bs-dismiss="modal"
            aria-label="Close"
          ></button>
        </div>

        <div class="modal-body">
          <exported-today />
        </div>

        <div class="modal-footer">
          <button
            type="button"
            class="btn btn-secondary"
            data-bs-dismiss="modal"
          >
            Fermer
          </button>
        </div>
      </div>
    </div>
  </div>

  <!-- Status details colios -->
  <div
    class="modal fade"
    id="modal_detail_colis"
    tabindex="-1"
    aria-hidden="true"
  >
    <div class="modal-dialog modal-dialog-centered modal-lg">
      <div class="modal-content p-15 p-md-40">
        <div class="modal-header">
          <h5 class="modal-title">Détails Colis</h5>
          <button
            type="button"
            class="btn-close"
            data-bs-dismiss="modal"
            aria-label="Fermer"
          ></button>
        </div>
        <div class="modal-body">
          <DetailsColis
            v-if="coliDetails"
            :coliDetails="coliDetails"
            :isOpen="isOpen"
          />
        </div>
      </div>
    </div>
  </div>

  <!-- Update Parcel Modal using Bootstrap -->
  <div class="modal fade" id="modal_update" tabindex="-1" aria-hidden="true">
    <div class="modal-dialog modal-dialog-centered modal-xl">
      <div class="modal-content p-15 p-md-40">
        <div class="modal-header">
          <h5 class="modal-title">Modifier Colis</h5>
          <button
            type="button"
            class="btn-close"
            data-bs-dismiss="modal"
            aria-label="Fermer"
          ></button>
        </div>
        <div class="modal-body">
          <UpdateParcel
            v-if="rowUpdate"
            :rowColis="rowUpdate"
            :getRecords="getRecords"
            :isOpenEdit="isOpenEdit"
            :hideModal="hideModal"
          />
        </div>
      </div>
    </div>
  </div>

   <!-- Status Update Modal using Bootstrap -->
  <div
    class="modal fade"
    id="modal_detail_suivi"
    tabindex="-1"
    aria-hidden="true"
  >
    <div class="modal-dialog modal-dialog-centered modal-xl">
      <div class="modal-content p-15 p-md-40">
        <div class="modal-header">
          <h5 class="modal-title">Historique Colis</h5>
          <button
            type="button"
            class="btn-close"
            data-bs-dismiss="modal"
            aria-label="Fermer"
          ></button>
        </div>
        <div class="modal-body">
          <HistoryColis
            v-if="colisId"
            :colisId="colisId"
            :isOpen="isOpen"
            :status="status"
          />
        </div>
      </div>
    </div>
  </div>

</template>

<script  lang="ts">
import { nextTick, onMounted, reactive, ref, computed } from "vue";
import flatpickr from "flatpickr";
import { useAuthStore } from "../../stores/auth";
import { useAppToast } from "@/composables/useAppToast";
import api from "@/utils/axios";
import moment from "moment";
import ExportedToday from "./ExportedToday.vue";
import { Modal } from "bootstrap";
import DetailsColis from "@/components/Colis/DetailsColis.vue";
import UpdateParcel from "@/components/Colis/UpdateParcel.vue";
import HistoryColis from "@/components/Colis/HistoryColis.vue";
import MyDateRangePicker from "@/components/MyDateRangePicker.vue";

import Swal from "sweetalert2";

export default {
  name: "ColisList",
  components: {
    ExportedToday,
    DetailsColis,
    UpdateParcel,
    HistoryColis,
    MyDateRangePicker
  },
  setup: () => {
    const { showToast } = useAppToast();
    const auth = useAuthStore();
    const user = auth.user;

    const rows = ref([]);
    const isLoader = ref(false);

    const filter = reactive({
      surrent_page: 1,
      per_page: 10,

      searchTerm: "",
      searchCustomer: "",
      searchZone: "",
      searchLiv: "",
      searchCity: "",
      searchEtat: "",
      searchStatut: "",
      searchSDate: "",
      searchEDate: "",
      searchTypeDate: "",
      searchBPL: "",
      searchRef: "",
      searchEmail: "",
      searchPrice: "",

      // (optional) pagination/meta from API:
      total: 0,
      last_page: 1,
      current_page: 1,
    });

    const zone_filter = ref({ id: "", name: "" });
    const client_filter = ref({ id: "", name: "" });
    const liv_filter = ref({ id: "", name: "" });
    const city_filter = ref({ id: "", name: "" });
    const status_filter = ref({ id: "", name: "", code: "" });

    const etat_filter = ref("");
    const type_date_filter = ref("");
    const add_bp_filter = ref("");
    const ref_filter = ref("");
    const email_filter = ref("");
    const price_filter = ref("");
    const searchTerm = ref("");

    interface Status {
      code: string;
      name: string;
      code_color?: string;
    }

    const status = ref<Status[]>([]);

    const clientList = ref<Status[]>([]);
    const zonesList = ref<Status[]>([]);
    const citiesList = ref<Status[]>([]);
    const livreurList = ref<Status[]>([]);
    const etatList = ref<Status[]>([]);

    function convert(date) {
      // example: to YYYY-MM-DD (adapt to your backend)
      const d = new Date(date);
      const m = String(d.getMonth() + 1).padStart(2, "0");
      const day = String(d.getDate()).padStart(2, "0");
      return `${d.getFullYear()}-${m}-${day}`;
    }

    function getDate(value) {
      if (value) return moment(String(value)).format("YYYY-MM-DD HH:mm");
      else return "";
    }

    const changePerPage = () => {
      filter.current_page = 1; // reset to first page when changing limit
      getRecords();
    };
    function buildQuery() {
      const params = new URLSearchParams({
        searchTerm: filter.searchTerm || "",
        searchCustomer: filter.searchCustomer || "",
        searchZone: filter.searchZone || "",
        searchLiv: filter.searchLiv || "",
        searchCity: filter.searchCity || "",
        searchEtat: filter.searchEtat || "",
        searchStatut: filter.searchStatut || "",
        searchSDate: filter.searchSDate || "",
        searchEDate: filter.searchEDate || "",
        searchTypeDate: filter.searchTypeDate || "",
        searchBPL: filter.searchBPL || "",
        searchRef: filter.searchRef || "",
        searchEmail: filter.searchEmail || "",
        searchPrice: filter.searchPrice || "",
        page: String(filter.current_page || 1),
        per_page: String(filter.per_page || 10),
      });
      return `/api/auth/new_colis_list?${params.toString()}`;
    }

    onMounted(async () => {
      flatpickr("#lead-calendar", {
        altInput: true,
        altFormat: "F j, Y",
        dateFormat: "Y-m-d",
        defaultDate: "today",
      });

      flatpickr("#basic-calendar", {
        dateFormat: "Y-m-d H:i",
      });
      getRecords();
      fetchStatus();

      try {
        const response = await api.get(`/api/auth/ListZone`);
        if (response && response.data) {
          zonesList.value = response.data;
          zonesList.value.unshift({ code: "0", name: "Tous" });
        }
      } catch (error) {
        console.error("Error fetching user data:", error);
      }

      try {
        const { data } = await api.get(`/api/auth/citiesList`);

        if (Array.isArray(data)) {
          citiesList.value = data;

          // Évite les doublons
          if (
            !citiesList.value.some(
              (city) => city.code === "" && city.name === "Tous"
            )
          ) {
            citiesList.value.unshift({ code: "", name: "Tous" });
          }
        }
      } catch (error) {
        console.error("Erreur lors du chargement des villes :", error);
        // showToast("Impossible de charger la liste des villes", "error")
      }
    });

    async function getRecords() {
      isLoader.value = true;
      try {
        const url = buildQuery();
        const { data } = await api.get(url);

        rows.value = data.users.data;

        // Keep your search fields; only update pagination/meta you need:
        filter.current_page = data.users.current_page;
        filter.per_page = data.users.per_page;
        filter.total = data.users.total;
        filter.last_page = data.users.last_page;

        // If you actually need all fields returned from backend:
        // Object.assign(users, { ...users, ...data.users })
      } finally {
        isLoader.value = false;
      }
    }

    function filterList() {
      filter.searchZone = zone_filter.value?.id || "";
      filter.searchCustomer = client_filter.value?.id || "";
      filter.searchLiv = liv_filter.value?.id || "";
      filter.searchCity = city_filter.value?.id || "";
      filter.searchEtat = etat_filter.value || "";
      filter.searchStatut = status_filter.value?.code || "";

      //   filter.searchSDate = myInput.value?.dateRange?.start
      //     ? convert(myInput.value.dateRange.start)
      //     : "";
      //   filter.searchEDate = myInput.value?.dateRange?.end
      //     ? convert(myInput.value.dateRange.end)
      //     : "";

      filter.searchTypeDate = type_date_filter.value || "";
      filter.searchBPL = add_bp_filter.value || "";
      filter.searchRef = ref_filter.value || "";
      filter.searchEmail = email_filter.value || "";
      filter.searchTerm = searchTerm.value || "";
      filter.searchPrice = price_filter.value || "";

      filter.current_page = 1;
      getRecords();
      hideModal("filterLeadModal");

    }

    function removeFilter() {
      // reset users filters
      filter.searchZone = "";
      filter.searchCustomer = "";
      filter.searchPrice = "";
      filter.searchLiv = "";
      filter.searchCity = "";
      filter.searchEtat = "";
      filter.searchStatut = "";

      filter.searchSDate = "";
      filter.searchEDate = "";
      filter.searchTypeDate = "";
      filter.searchBPL = "";
      filter.searchRef = "";
      filter.searchEmail = "";
      filter.searchTerm = "";
      filter.current_page = 1;

      // reset local UI models
      etat_filter.value = "";
      add_bp_filter.value = "";
      ref_filter.value = "";
      email_filter.value = "";
      type_date_filter.value = "";
      price_filter.value = "";
      searchTerm.value = "";

      zone_filter.value = { id: "", name: "" };
      client_filter.value = { id: "", name: "" };
      liv_filter.value = { id: "", name: "" };
      city_filter.value = { id: "", name: "" };
      status_filter.value = { id: "", name: "", code: "" };

      // clear date range picker model
      //   if (!myInput.value) myInput.value = { dateRange: {} }
      //   myInput.value.dateRange = {}

      getRecords();
      hideModal("filterLeadModal");

    }

    async function fetchStatus() {
      try {
        const response = await api.get("/api/auth/AllStatus");
        if (response && response.data) {
          status.value = response.data;
        }
      } catch (error) {
        console.error("Error fetching statuses:", error);
      }
    }

    function goToPage(page) {
      if (page < 1 || page > filter.last_page) return;
      filter.current_page = page;
      getRecords();
    }

    function oldPhone(val) {
      if (val && val !== "" && val != null) {
        let phone = "";
        if (val.substring(0, 4) === "+212" && val.length === 13) {
          return `0${val.slice(4)}`;
        }
        if (val.substring(0, 3) === "212" && val.length === 12) {
          phone = `0${val.slice(2)}`;
          return phone;
        }
        if (val.substring(0, 1) === "0" && val.length === 10) {
          return val;
        }
        if (
          val.substring(0, 1) === "6" ||
          (val.substring(0, 1) === "7" && val.length === 9)
        ) {
          // phone = "+212" + val;
          return val;
        }
        if (val.substring(0, 5) === "00212" && val.length === 14) {
          return `0${val.substring(0, 5)}`;
        }
      } else {
        return val;
      }
    }
    function globalHelper(s: string) {
      if (!s || s === "undefined") {
        return null; // always return null for invalid values
      }

      return status.value.find((o) => o.code === s) || null;
    }

    function removeHours(value) {
      if (value && value !== "") {
        const datePart = value.split(" ")[0];
        return datePart;
      }
    }
    function reported(date) {
      const currentDate = new Date();
      const reportedDate = new Date(date);
      if (reportedDate.getTime() <= currentDate.getTime()) {
        return true;
      } else {
        return false;
      }
    }
    function resolveStatuParcel(status) {
      if (status === "POSTPONED") return "Reporté";
      if (status === "DELIVERED") return "Livré";
      if (status === "PAID") return "Payé";
      if (status === "NOT_PAID") return "Non Payé";
      if (status === "Payé") return "Payé";
      if (status === "CANCELED") return "Annulé";
      if (status === "UNREACHABLE") return "Injoignable";
      if (status === "POSTPONED") return "Reporté";
      if (status === "RETURNED") return "Retourné";
      if (status === "RECEIVED") return "Reçu";
      if (status === "OUT_OF_AREA") return "Hors-zone";
      if (status === "NOANSWER") return "Pas de réponse + SMS";
      if (status === "SENTED") return "Expédié";
      if (status === "REFUSE") return "Refusé";
      if (status === "ONV") return "En Voyage";
      if (status === "INT") return "Client intéréssé";
      if (status === "POSTPONED_TEAM") return "Reporté ( SUIVI )";
      if (status === "CANCELED_TEAM") return "Annulé ( SUIVI )";
      if (status === "VOICEMAIL_TEAM") return "Boite Vocal ( SUIVI )";
      if (status === "EN") return "Erreur Numéro";
      return status;
    }

    function resolveUserStatusVariant(status) {
      if (status === "PICKED_UP") return "warning";
      if (status === "DELIVERED") return "success";
      if (status === "PAID") return "info";
      if (status === "NOT_PAID") return "danger";
      if (status === "Payé") return "info";
      if (status === "Non Payé") return "warning";
      if (status === "Facturé") return "info";
      return "primary";
    }

    function getStatusName(code?: string) {
      return code ? globalHelper(code)?.name || "" : "";
    }

    function getStatusColor(code?: string) {
      return code ? globalHelper(code)?.code_color || "#000" : "#000";
    }

    function formatReported(row: any) {
      return removeHours(row.reported_date);
    }

    // Decide what to show in badge
    function getBadgeConfig(row: any) {
      // IN_PROGRESS with secondary status
      if (
        row.status === "IN_PROGRESS" &&
        row.status_second &&
        getStatusName(row.status_second)
      ) {
        if (
          ["POSTPONED", "PROGRAMED", "POSTPONED_TODAY"].includes(
            row.status_second
          )
        ) {
          return {
            text: getStatusName(row.status_second),
            date: formatReported(row),
            color: reported(row.reported_date)
              ? "#E50A0A"
              : getStatusColor(row.status_second),
          };
        }
        return {
          text: getStatusName(row.status_second),
          color: getStatusColor(row.status_second),
        };
      }

      // RETURNED but not REFUSE
      if (
        row.status === "RETURNED" &&
        (!row.status_second || row.status_second !== "REFUSE") &&
        row.last_statut_comment
      ) {
        return {
          text:
            row.rn_e && row.rn_e !== 0
              ? `${row.statut.s_name} Endommagé`
              : row.statut.s_name,
          comment: row.last_statut_comment,
          color: row.statut.code_color,
        };
      }

      // RETURNED with REFUSE
      if (
        row.status === "RETURNED" &&
        row.status_second === "REFUSE" &&
        getStatusName(row.status_second)
      ) {
        return {
          text:
            row.rn_e && row.rn_e !== 0
              ? `Retourné Endommagé - ${getStatusName(row.status_second)}`
              : `Retourné - ${getStatusName(row.status_second)}`,
          comment: row.last_statut_comment,
          color: getStatusColor(row.status_second),
        };
      }

      // Default
      return {
        text:
          row.rn_e && row.rn_e !== 0 && row.status === "RETURNED"
            ? `${row.statut.s_name} Endommagé`
            : row.statut.s_name,
        color: row.statut.code_color,
      };
    }

    let debounceTimeout: number | undefined;

    // function onSearchClients(search, loading) {
    //   clearTimeout(this.searchTimeout)
    //   this.searchTimeout = setTimeout(() => {
    //     this.filterClients(search, loading)
    //   }, 300) // Debounce time in milliseconds
    // },

    async function filterClients(search: string, loading: { value: boolean }) {
      const query = search.trim().toLowerCase();

      if (!query) {
        clientList.value = [];
        return;
      }

      // Debounce to avoid too many API calls
      if (debounceTimeout) clearTimeout(debounceTimeout);

      debounceTimeout = window.setTimeout(async () => {
        try {
          const res = await api.get(`/api/auth/ListCustsFilter`, {
            params: { query },
          });
          clientList.value = res.data;
          clientList.value.unshift({ code: "", name: "Tous" });
        } catch (error) {
          console.error("Error fetching clients:", error);
          clientList.value = [];
        }
      }, 300); // 300ms debounce
    }

    async function onSearchDrivers(
      search: string,
      loading: { value: boolean }
    ) {
      const query = search.trim().toLowerCase();

      if (!query) {
        livreurList.value = [];
        return;
      }

      // Debounce to avoid too many API calls
      if (debounceTimeout) clearTimeout(debounceTimeout);

      debounceTimeout = window.setTimeout(async () => {
        try {
          const res = await api.get(`/api/auth/LivsList`, {
            params: { query },
          });
          livreurList.value = res.data;
          livreurList.value.unshift({ code: "", name: "Tous" });
        } catch (error) {
          console.error("Error fetching clients:", error);
          livreurList.value = [];
        }
      }, 300); // 300ms debounce
    }
    const isOpen = ref(false);
    const coliDetails = ref<any>({});

    async function showDetails(row) {
      isOpen.value = false;
      coliDetails.value = null;

      await nextTick();
      coliDetails.value = row;
      isOpen.value = true;

      await nextTick();

      const modalEl = document.getElementById("modal_detail_colis");
      if (modalEl) {
        const modal = new Modal(modalEl);
        isOpen.value = true;
        modal.show();
      }
      // TODO: Open info modal
    }

    // -------------------------------
    const rowUpdate = ref(null);
    const isOpenEdit = ref(false);
    // Show update modal
    async function showUpdate(row) {
      rowUpdate.value = null;
      isOpenEdit.value = false;
      rowUpdate.value = row;
      nextTick(() => {
        const modalEl = document.getElementById("modal_update");
        console.log(modalEl);
        if (modalEl) {
          isOpenEdit.value = true; // triggers watcher in child

          const modal = new Modal(modalEl);
          modal.show();
        }
      });
    }

    function hideModal(idModal) {
      const modalEl = document.getElementById(idModal);
      const modal = Modal.getInstance(modalEl) || new Modal(modalEl);
      if (modal) {
        modal.hide();
      }
    }

    async function Destroy_Coli(row: any) {
      console.log("Deleting parcel:", row);
      Swal.fire({
        text: "Vous voulez supprimer ce colis ?",
        icon: "warning",
        showCancelButton: true,
        confirmButtonColor: "#3085d6",
        cancelButtonColor: "#d33",
        confirmButtonText: "Oui, supprimer!",
      }).then(async (result: any) => {
        if (result.isConfirmed) {
          const data = new FormData();
          data.append("parcel_id", row.id);
          data.append("parcel_code", row.code);
          try {
            const res = await api.post(`/api/auth/removeParcel`, data);
            if (res.data.message === "success") {
              showToast("Colis supprimé avec succès", "success");
              getRecords();
            } else if (res.data.message === "error") {
              showToast("Vous pouvez pas supprimer ce colis", "error");
            }
          } catch (error) {
            showToast("Erreur lors de la suppression du colis", "error");
          }
        }
      });
    }

    const colisId = ref(null);

    async function showDetailSuivi(row) {
      isOpen.value = false;
      colisId.value = null;

      await nextTick();

      colisId.value = row.id;
      isOpen.value = true;
      await nextTick();
      const modalEl = document.getElementById("modal_detail_suivi");
      if (modalEl) {
        const modal = new Modal(modalEl);
        isOpen.value = true;
        modal.show();
      }
      // TODO: Open history modal
    }

    const debounceTimer = ref<number | undefined>(undefined);

    function handleInput() {
      if (debounceTimer.value) clearTimeout(debounceTimer.value);
      debounceTimer.value = window.setTimeout(() => {
        filter.searchTerm = searchTerm.value;
        filter.current_page = 1;
        getRecords();
      }, 500);
    }

    const todayDt = moment();
    const firstDt = moment().subtract(8, "M");
    const selectedDate = ref(null);

    const showCalendarBox = ref(false);

    function showCalendar() {
      console.log(selectedDate.value)
      showCalendarBox.value = !showCalendarBox.value;
    }

    const paginatedPages = computed(() => {
      const total = filter.last_page;
      const current = filter.current_page;
      const delta = 2;
      const pages: (number | string)[] = [];

      if (total <= 7) {
        for (let i = 1; i <= total; i++) pages.push(i);
        return pages;
      }

      pages.push(1);

      const left = Math.max(2, current - delta);
      const right = Math.min(total - 1, current + delta);

      if (left > 2) pages.push("...");
      for (let i = left; i <= right; i++) pages.push(i);
      if (right < total - 1) pages.push("...");

      pages.push(total);
      return pages;
    });

    return {
      auth,
      rows,
      goToPage,
      filter,
      getDate,
      oldPhone,
      globalHelper,
      removeHours,
      reported,
      resolveStatuParcel,
      resolveUserStatusVariant,
      getBadgeConfig,
      zone_filter,
      client_filter,
      liv_filter,
      city_filter,
      status_filter,

      etat_filter,
      type_date_filter,
      add_bp_filter,
      ref_filter,
      email_filter,
      price_filter,
      searchTerm,

      clientList,
      zonesList,
      citiesList,
      livreurList,
      etatList,
      status,

      filterClients,
      onSearchDrivers,
      filterList,
      removeFilter,
      changePerPage,
      showDetails,
      isLoader,
      user,
      isOpen,
      coliDetails,
      rowUpdate,
      isOpenEdit,
      getRecords,
      hideModal,
      showUpdate,
      Destroy_Coli,
      colisId,
      showDetailSuivi,
      handleInput,
      todayDt,
      firstDt,
      selectedDate,
      showCalendar,
      showCalendarBox,
      paginatedPages,
    };
  },
};
</script>